(ns machtfit.widgets.checkbox
  (:require
   [machtfit.widgets.icon :as icon]
   [machtfit.widgets.shared :as shared]))

(defn checkbox [{:keys [label
                        hint
                        checked?
                        indeterminate?
                        disabled?
                        on-click
                        size]
                 :or {checked? false
                      indeterminate? false
                      disabled? false
                      size :md}}]
  [:div.w-fit.flex.justify-start.items-start.gap-2 {:on-click (when-not disabled?
                                                                on-click)
                                                    :class (when (and on-click (not disabled?))
                                                             "cursor-pointer")}
   [:div {:role "checkbox"
          :disabled disabled?
          :checked checked?
          :aria-checked (cond
                          indeterminate? "mixed"
                          checked? "true"
                          :else "false")
          :aria-readonly (when-not on-click "true")
          :tabIndex 0
          :on-key-down (when (and on-click (not disabled?))
                         (fn [event]
                           (when (= " " (.-key event))
                             (.preventDefault event)
                             (when-not (.-repeat event)
                               (on-click event)))))
          :class [(case size :lg "w-6" "w-5")
                  (case size :lg "h-6" "h-5")
                  "pt-0.5"
                  "flex"
                  "justify-center"
                  "items-center"
                  "shrink-0"
                  "rounded"
                  "transition-colors"
                  "duration-200"
                  "ease-in-out"
                  "outline-none"
                  "focus-visible:ring-4"
                  (cond
                    (and checked? (not disabled?)) "bg-brand-500 focus-visible:ring-brand-500/25"
                    (and indeterminate? (not disabled?)) "border border-brand-500 focus-visible:ring-brand-500/25"
                    disabled? "bg-gray-50 border focus-visible:ring-gray-300/25"
                    :else "border focus-visible:ring-gray-300/25")]}
    (when (or checked? indeterminate?)
      [icon/outline "check" {:width (case size :lg "w-4" "w-3.5")
                             :height (case size :lg "h-4" "h-3.5")
                             :stroke (cond
                                       disabled? "stroke-gray-200"
                                       indeterminate? "stroke-brand-500"
                                       :else "stroke-white")}])]
   (when (or label hint)
     [:div.flex.flex-col.grow.shrink.basis-0.justify-start.items-start
      (when label
        [:span.text-base.text-gray-900.leading-tight label])
      (when hint
        [shared/hint {:text hint}])])])
